import { Component, OnDestroy, OnInit, forwardRef, DoCheck } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonDataService } from '../../../_infrastructure/CommonData/CommonDataService';
import { PreFilledProperty } from '../../../_infrastructure/Models/pre-filled-property.interface';
import { isNotNullOrUndefinedOrEmpty, isNullOrUndefined } from '../../../_infrastructure/objectUtils';
import { ICardComponentInjectionToken } from '../../../_infrastructure/ValidationMessages/ExternalValidationDirective';
import { WorkflowComponentNew } from '../../workflow-new.component';
@Component({
  selector: 'sender-identification',
  templateUrl: './sender-identification.component.html',
  providers: [
    {
      provide: ICardComponentInjectionToken,
      useExisting: forwardRef(() => SenderIdentificationComponent)
    }],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  standalone: false
})

export class SenderIdentificationComponent implements OnInit, OnDestroy {
  public documentTypes: models.DimensionVM[];
  public maritalStatus: models.Options[];
  public genders: models.DimensionVM[];
  public yesNo: models.DimensionVM[];
  /*@CommonData(DomainCodes.nationality)*/
  public nationalities: models.DimensionVM[];

  public preFilledProperties: PreFilledProperty[] = [];
  private isFirstChange: boolean = true;
  public isCommonDataLoaded: boolean = false;
  public mainSubscription: Subscription = new Subscription();
  public isServiceOrFunerary: boolean;

  constructor(private commonDataService: CommonDataService) {
    const domains = [
      DomainCodes.yesNo,
      DomainCodes.nationality,
      DomainCodes.genders,
      DomainCodes.martialStatus,
      DomainCodes.identificationType
    ];

    this.mainSubscription.add(
      this.commonDataService.getDomains(domains).subscribe(
        (results: models.DomainVM[]) => {
          this.yesNo = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.yesNo).dimensions;
          this.nationalities = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.nationality).dimensions;
          this.genders = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.genders).dimensions;
          //this.maritalStatus = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.martialStatus).dimensions;
          this.documentTypes = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.identificationType).dimensions;
          this.isCommonDataLoaded = true;
        }
      )
    );
  }


  // Declaramos o cardData como get + set em vez de variável simples pois precisamos abaixo de agarrar lógica ao momento
  //  de atualização do cardData ( evita o ngDoCheck ou ngOnChanges ou afins )
  public get cardData(): models.SenderIdentificationVM{
    return this._cardData;
  }
  public set cardData(value: models.SenderIdentificationVM) {
    this._cardData = value;
    this.firstOnCardChanged();
    this.onCardDataChanged(); // Este é o método chamado quando temos mudança no cardData ( atualizado pelo step ), abaixo temos a implementação e a lógica
  }
  private _cardData: models.SenderIdentificationVM = {} as models.SenderIdentificationVM;

  public parentWorkflow: WorkflowComponentNew;

  ngOnInit(): void {
    this.isServiceOrFunerary = this.parentWorkflow.workflowInstance.StepSender.SenderQualification.isServiceOrFunerary?.toString() == 'true';
    this.maritalStatus = this.parentWorkflow.workflowDropdowns.options
      .filter(el => el.dropdown === "dropListMaritalStatus");
  }

  ngOnDestroy(): void {

  }

  private firstOnCardChanged(): void {
    if (this.isFirstChange) {
      this.isFirstChange = false;
      this.preFilledProperties.push({ name: "name", preFilledValue: this.cardData.name, hasValue: isNotNullOrUndefinedOrEmpty(this.cardData.name) });
      this.preFilledProperties.push({ name: "dateOfBirth", preFilledValue: this.cardData.dateOfBirth, hasValue: !isNullOrUndefined(this.cardData.dateOfBirth) });
      this.preFilledProperties.push({ name: "hasNacPT", preFilledValue: this.cardData.hasNacPT, hasValue: isNotNullOrUndefinedOrEmpty(this.cardData.hasNacPT) });
      this.cardData.hasNIFPT = true;
      this.preFilledProperties.push({ name: "hasNIFPT", preFilledValue: this.cardData.hasNIFPT, hasValue: isNotNullOrUndefinedOrEmpty(this.cardData.hasNIFPT) });
      this.preFilledProperties.push({ name: "NIF", preFilledValue: this.cardData.NIF, hasValue: isNotNullOrUndefinedOrEmpty(this.cardData.NIF) });
      this.preFilledProperties.push({ name: "gender", preFilledValue: this.cardData.gender, hasValue: isNotNullOrUndefinedOrEmpty(this.cardData.gender) });
      this.preFilledProperties.push({ name: "civilState", preFilledValue: this.cardData.civilState, hasValue: isNotNullOrUndefinedOrEmpty(this.cardData.civilState) });
      this.preFilledProperties.push(
        {
          name: "identificationNumberFirst",
          preFilledValue: this.cardData.identificationNumberFirst,
          hasValue: isNotNullOrUndefinedOrEmpty(this.cardData.identificationNumberFirst)
        });
      this.preFilledProperties.push(
        {
          name: "identificationNumberLast",
          preFilledValue: this.cardData.identificationNumberLast,
          hasValue: isNotNullOrUndefinedOrEmpty(this.cardData.identificationNumberLast)
        });
      this.preFilledProperties.push(
        {
          name: "nationality",
          preFilledValue: this.cardData.nationality,
          hasValue: isNotNullOrUndefinedOrEmpty(this.cardData.nationality)
        });
      //Corrigir a NAcionalidade, pois se tem nacionalide portuguesa é para atualizar o campo
      if (this.cardData.hasNacPT?.toString() == "true") {
        this.cardData.nationality = "PT";
      }
    }
  }

  public isFieldDisabled(name: string): boolean {
    let result = this.preFilledProperties.find(el => el.name == name).hasValue;
    return result;
  }


  private onCardDataChanged() {

    this.cardData.name = this.parentWorkflow.workflowInstance.StepSender?.SenderIdentification?.name;
    this.cardData.dateOfBirth = this.parentWorkflow.workflowInstance.StepSender?.SenderIdentification?.dateOfBirth;
    this.cardData.NIF = this.parentWorkflow.workflowInstance.StepSender?.SenderIdentification?.NIF;


  }

}
